import { createStore } from "vuex";

// Roles allowed to use Dismantling & Compliance. Mirrors COMPLIANCE_ROLES in the API
// (api/constants/compliance.js), which is what actually enforces it.
const COMPLIANCE_ROLES = ["User", "InstitutionManager", "InstitutionAdmin"];

export default createStore({
  state: {
    user_id: "",
    user_name: "",
    approved_parts_number: 0,
    used_plates_number: 0,
    institution_id: "",
    institution_email: "",
    institution_export_ebay_leko: false,
    institution_export_google_leko: false,
    institution_display_features: null,
    instiution_ebay_international: null,
    role: "",
    vehicles: 0,
    temporary_parts: 0,
    inventory: 0,
    total_parts: 0,
    approved_parts: [],
    active: { active: false },
    language: "en",
    loading: false,
    logged: false,
    ordered_parts: 0,
    user_email: "",
    rr_member: false,
    azienda_rr: false,
    institution_rr: false,
    hasUnpaidInvoices: false,
    remaining_plates_number: 0,
    refused_catalog_title: false,
    compliance_enabled: false,
    compliance_pra_enabled: false,
    compliance_workshop_enabled: false,
    compliance_waste_enabled: false,
    permissions: [],
  },
  mutations: {
    auth_success(state, data) {
      state.logged = true;
      state.user_id = data._id;
      state.user_name = data.name;
      state.approved_parts_number = data.approved_parts_number;
      state.used_plates_number = data.used_plates_number;
      state.institution_id = data.institution_id;
      state.institution_email = data.institution_email;
      state.role = data.role;
      state.vehicles = data.vehicles;
      state.temporary_parts = data.temporary_parts;
      state.inventory = data.inventory;
      state.total_parts = data.total_parts;
      state.ordered_parts = data.ordered_parts;
      state.instiution_ebay_international = data.export_ebay_international;
      state.user_email = data.email;
      state.rr_member = data.rr_member;
      state.hasUnpaidInvoices = data.hasUnpaidInvoices;
      state.refused_catalog_title = data.refused_catalog_title === true;
      state.permissions = Array.isArray(data.permissions) ? data.permissions : [];
      // state.remaining_plates_number =
      // data.plates && data.plates.remaining ? data.plates.remaining : 0;
    },
    set_language(state, lang) {
      state.language = lang;
    },
    active_mutation(state, data) {
      state.active = data;
    },
    logout(state) {
      state.logged = false;
      state.user_id = "";
      state.user_name = "";
      state.institution_id = "";
      state.role = "";
      state.vehicles = 0;
      state.temporary_parts = 0;
      state.inventory = 0;
      state.total_parts = 0;
      state.ordered_parts = 0;
      state.instiution_ebay_international = null;
      // state.language = '';
      state.rr_member = false;
      state.azienda_rr = false;
      state.institution_rr = false;
      state.hasUnpaidInvoices = false;
      state.remaining_plates_number = 0;
      state.refused_catalog_title = false;
      state.compliance_enabled = false;
      state.compliance_pra_enabled = false;
      state.compliance_workshop_enabled = false;
      state.compliance_waste_enabled = false;
      state.permissions = [];
    },
    start_loading(state) {
      state.loading = true;
    },
    finish_loading(state) {
      state.loading = false;
    },
    set_institution_export_ebay_leko(state, data) {
      state.institution_export_ebay_leko = data;
    },
    set_institution_export_google_leko(state, data) {
      state.institution_export_google_leko = data;
    },
    set_institution_display_features(state, data) {
      state.institution_display_features = data;
    },
    set_rr_member(state, data) {
      state.rr_member = data;
    },
    set_azienda_rr(state, data) {
      state.azienda_rr = data;
    },
    set_institution_rr(state, data) {
      state.institution_rr = data;
    },
    setHasUnpaidInvoices(state, data) {
      state.hasUnpaidInvoices = data;
    },
    setRemainingPlates(state, data) {
      state.remaining_plates_number = data;
    },
    set_refused_catalog_title(state, data) {
      state.refused_catalog_title = data === true;
    },
    set_compliance_enabled(state, data) {
      state.compliance_enabled = data === true;
    },
    set_compliance_pra_enabled(state, data) {
      state.compliance_pra_enabled = data === true;
    },
    set_compliance_workshop_enabled(state, data) {
      state.compliance_workshop_enabled = data === true;
    },
    set_compliance_waste_enabled(state, data) {
      state.compliance_waste_enabled = data === true;
    },
    // set_institution_ebay_sites(state, data) {
    //   state.instiution_ebay_international = data;
    // },
    /*
    set_approved_parts(state, approvedParts) {
      state.approved_parts = approvedParts;
    },
    */
  },
  actions: {
    languageAction({ commit }, lang) {
      commit("set_language", lang);
    },
    verifyToken({ commit }, data) {
      commit("auth_success", data);
    },
    activeAction({ commit }, data) {
      commit("active_mutation", data);
    },
    logoutAction({ commit }) {
      commit("logout");
    },
    startLoading({ commit }) {
      commit("start_loading");
    },
    finishLoading({ commit }) {
      commit("finish_loading");
    },
    institutionExportEbayLekoAction({ commit }, data) {
      commit("set_institution_export_ebay_leko", data);
    },
    institutionExportGoogleLekoAction({ commit }, data) {
      commit("set_institution_export_google_leko", data);
    },
    institutionDisplayFeaturesAction({ commit }, data) {
      commit("set_institution_display_features", data);
    },
    setRrMember({ commit }, data) {
      commit("set_rr_member", data);
    },
    setAziendaRR({ commit }, data) {
      commit("set_azienda_rr", data);
    },
    setInstitutionRr({ commit }, data) {
      commit("set_institution_rr", data);
    },
    setHasUnpaidInvoices({ commit }, data) {
      commit("setHasUnpaidInvoices", data);
    },
    setRemainingPlates({ commit }, data) {
      commit("setRemainingPlates", data);
    },
    setComplianceEnabled({ commit }, data) {
      commit("set_compliance_enabled", data);
    },
    setCompliancePraEnabled({ commit }, data) {
      commit("set_compliance_pra_enabled", data);
    },
    setComplianceWorkshopEnabled({ commit }, data) {
      commit("set_compliance_workshop_enabled", data);
    },
    setComplianceWasteEnabled({ commit }, data) {
      commit("set_compliance_waste_enabled", data);
    },
    /*
    approvedPartsAction({ commit }, approvedParts) {
      commit('set_approved_parts', approvedParts);
    },
    */
  },
  getters: {
    logged(state) {
      return state.logged;
    },
    userId(state) {
      return state.user_id;
    },
    userName(state) {
      return state.user_name;
    },
    approvedPartsNumber(state) {
      return state.approved_parts_number;
    },
    usedPlatesNumber(state) {
      return state.used_plates_number;
    },
    institutionId(state) {
      return state.institution_id;
    },
    institutionEmail(state) {
      return state.institution_email;
    },
    institutionExportEbayLeko(state) {
      return state.institution_export_ebay_leko;
    },
    institutionExportGoogleLeko(state) {
      return state.institution_export_google_leko;
    },
    institutionDisplayFeatures(state) {
      return state.institution_display_features;
    },
    institutionEbayInternational(state) {
      return state.instiution_ebay_international;
    },
    role(state) {
      return state.role;
    },
    refusedCatalogTitleEnabled(state) {
      return state.refused_catalog_title === true;
    },
    // Institution switch on AND a role that may use the module.
    complianceEnabled(state) {
      return (
        state.compliance_enabled === true &&
        COMPLIANCE_ROLES.includes(state.role)
      );
    },
    // PRA deregistration case (Stage 2): the module as above AND the institution PRA switch.
    // Cosmetic only; the API checks dismantlingCompliance.pra itself.
    praEnabled(state, getters) {
      return getters.complianceEnabled && state.compliance_pra_enabled === true;
    },
    // Workshop depollution checklist (Stage 3a): the module as above AND the institution workshop
    // switch. Cosmetic only; the API checks dismantlingCompliance.workshop itself.
    workshopEnabled(state, getters) {
      return (
        getters.complianceEnabled && state.compliance_workshop_enabled === true
      );
    },
    // Waste containers (Stage 6): the workshop as above AND the institution waste switch.
    // Cosmetic only; the API checks dismantlingCompliance.waste itself.
    wasteEnabled(state, getters) {
      return getters.workshopEnabled && state.compliance_waste_enabled === true;
    },
    vehicles(state) {
      return state.vehicles;
    },
    temporaryParts(state) {
      return state.temporary_parts;
    },
    inventory(state) {
      return state.inventory;
    },
    totalParts(state) {
      return state.total_parts;
    },
    language(state) {
      return state.language;
    },
    active(state) {
      return state.active;
    },
    loading(state) {
      return state.loading;
    },
    orderedParts(state) {
      return state.ordered_parts;
    },
    userEmail(state) {
      return state.user_email;
    },
    rr_member(state) {
      return state.rr_member;
    },
    aziendaRR(state) {
      return state.azienda_rr;
    },
    institutionRr(state) {
      return state.institution_rr;
    },
    hasUnpaidInvoices(state) {
      return state.hasUnpaidInvoices;
    },
    remainingPlatesNumber(state) {
      return state.remaining_plates_number;
    },
    permissions(state) {
      return state.permissions;
    },
    /*
    approvedParts(state) {
      return state.approved_parts;
    },
    */
  },
});
